import { QRCode } from 'react-qrcode-logo';

function QrcodeDiv(props){
    return <>
        <QRCode value={props.stamp_code} 
            logoImage={props.stamp_icon} 
            size="200" 
            ecLevel="H" 
            logoWidth="50" ></QRCode>
    </>
};

export default QrcodeDiv;